<template>
  <div>
   
      <b-carousel id="carousel1"
                :controls="controls"
                :indicators="indicators"
                background="#ababab"
                :interval="6000"
    >
    <nav-bar ></nav-bar>
      <b-carousel-slide v-for="item in a" :key="item.id">
        <!-- <img slot="img" class="d-block  w-100" 
             :src="item" alt="image slot"> -->

             <picture slot="img" id="pic">
                  <source media="(max-width: 575px)" :srcset="item.xs">
                  <source media="(max-width: 767px)" :srcset="item.sm">
                  <source media="(max-width: 991px)" :srcset="item.md">
                  <source media="(max-width: 1199px)" :srcset="item.lg">
                  <img  class="d-block  w-100" :src="item.xl"  >
                </picture>
      </b-carousel-slide>


    </b-carousel>
   
<div style="border-bottom: 20px solid rgb(185, 40 , 45) !important"></div>
  </div>
</template>

<script>
import NavBar from "./NavBar";
export default {
  props: ['a'],
  data () {
    return {
      
      controls:true,
      indicators:true,

    }
  },
  components: {
    NavBar,
  },
  
  computed:{
    showindicator:function(){
      if(this.a.length<=1){
        // console.log(this.a.length);
        this.controls=false;
        this.indicators=false;
        return false
      }
      else{
        console.log(this.a.length);
        this.controls=true;
        this.indicators=true;
        return true
      }
    }
  },
  created(){
    

    
  },
  methods:{
    // changein(){
    //   this.count+=1;
    //   if(this.count%2==0){this.controls=true;
    //     this.indicators=true;}
    //   else{this.controls=false;
    //     this.indicators=false;}
    //     //ok
    // }
  },
   updated () {
  this.showindicator;
  
},
mounted(){
  
},
}
</script>
<!-- carousel-1.vue -->
<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue